import React, { useCallback } from 'react';
import { Select, MenuItem, Typography, SelectChangeEvent } from '@mui/material';
import DynamicArgsWrapper from '../../containers/ArgsWarpper/ArgsWrapper';
import { TArgs } from '../../types/policies-types';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import { MenuProps } from './constants';
import { updateProfilePolicyArgs } from '../../actions/policies-profile-actions/policy-state-actions';

const StringArrayField: React.FC<React.PropsWithChildren<TArgs>> = props => {
  const {
    name: argName,
    label,
    value: initValue,
    range,
    policyId,
    tooltip,
  } = props;

  const handleChange = useCallback(
    (event: SelectChangeEvent<typeof initValue>) => {
      const { name, value } = event.target;
      enablePoliciesSaveButton(true);

      updateProfilePolicyArgs({
        id: policyId,
        name,
        value,
      });
    },
    [policyId],
  );

  return (
    <DynamicArgsWrapper
      meta={{
        name: argName,
        label,
        tooltip,
      }}>
      <Select
        size='small'
        value={initValue}
        name={argName}
        label={label}
        renderValue={selected => (
          <Typography lineHeight='unset' variant='body2'>
            {selected}
          </Typography>
        )}
        onChange={handleChange}
        MenuProps={MenuProps}
        sx={{
          minWidth: 218,
          paddingLeft: '2px',
        }}>
        {(range as string[]).map((item: string) => (
          <MenuItem key={item} value={item}>
            <Typography variant='body2'>{item}</Typography>
          </MenuItem>
        ))}
      </Select>
    </DynamicArgsWrapper>
  );
};

export default StringArrayField;
